export default __webpack_public_path__ + "static/media/girl_banner.5103421d.png";